import React, { useEffect, useState } from "react";
import { appTitle, dateFormat, FollowUpEventStatus } from "../common/GeneralConfigurations";
import HomeForm from "./HomeForm";
import SatisfactionDetailModal from "./SatisfactionDetailModal";
import ConsultantsEntryAndExitDetailModal from "./ConsultantsEntryAndExitDetailModal";
import { getEmployeeCounters, getNewEmployees } from "../../api/EmployeeApi";
import {
    getEmployeeFollowUpEventStatistics,
    getEmployeesSatisfactionLevels,
    getEmployeeStatisfactionLevelsDetails,
    getUserEmployeeFollowUpEventsCounter,
    getEmployeeFollowUpEventsByDateAndStatusCounter,
} from "../../api/EmployeeFollowUpEventApi";
import { getContractProposalsStatistics } from "../../api/ContractProposalApi";
import { getOffersStatistics } from "../../api/OfferType";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../AppRoutes";

const ManageHome = () => {
    const [loading, setLoading] = useState(true);
    const [isSatisfactionModalVisible, setIsSatisfactionModalVisible] =
        useState(false);
    const [isEntriesAndExitsModalVisible, setIsEntriesAndExitsModalVisible] =
        useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [newConsultants, setNewConsultants] = useState([]);

    const [activeConsultantsCount, setAtiveConsultantsCount] = useState([]);
    const [newConsultantsCount, setNewConsultantsCount] = useState([]);
    const [resignatedConsultantsCount, setResignatedConsultantsCount] = useState(
        []
    );

    const [companySatisfaction, setCompanySatisfaction] = useState(undefined);
    const [projectSatisfaction, setProjectSatisfaction] = useState(undefined);
    const [clientSatisfaction, setClientSatisfaction] = useState(undefined);

    const [contractProposalMonth, setContractProposalMonth] = useState(
        new Date().getMonth() + 1
    );
    const [contractProposalYear, setContractProposalYear] = useState(
        new Date().getFullYear()
    );
    const [contractProposalData, setContractProposalData] = useState(null);

    const [employeeFollowUpEventMonth, setEmployeeFollowUpEventMonth] = useState(
        new Date().getMonth() + 1
    );
    const [employeeFollowUpEventYear, setEmployeeFollowUpEventYear] = useState(
        new Date().getFullYear()
    );
    const [employeeFollowUpEventData, setEmployeeFollowUpEventData] =
        useState(null);
    const [userEmployeeFollowUpEventData, setUserEmployeeFollowUpEventData] =
        useState(null);

    const [offerTypeMonth, setOfferTypeMonth] = useState(
        new Date().getMonth() + 1
    );
    const [offerTypeYear, setOfferTypeYear] = useState(new Date().getFullYear());
    const [offerTypeData, setOfferTypeData] = useState(null);

    const [newResignConsultants, setNewResignConsultants] = useState(false);
    const [monthlyEventsSearch, setMonthlyEventsSearch] = useState("All");
    const [badgesColors, setBadgesColors] = useState([]);
    const [monthlyEventsList, setMonthlyEventsList] = useState([]);
    const navigate = useNavigate();
    const date = moment(moment(), dateFormat);
    const currentMonth = date.month() + 1;
    const year = date.year();

    const FirstLastName = (name) => {
        const nameArray = name.split(" ");
        const firstName = nameArray[0];
        const lastNameLetter = nameArray[nameArray.length - 1][0];

        const firstLastName = firstName + " " + lastNameLetter + ".";

        return firstLastName;
    };

    const [mostSatisfiedConsultantsConfig, setMostSatisfiedConsultantsConfig] =
        useState({
            data: [],
            width: 900,
            height: 150,
            xField: "employeeName",
            yField: "level",
            color: "green",
            label: {
                position: "middle",
                style: {
                    fill: "#FFFFFF",
                    opacity: 0.6,
                },
            },
            xAxis: {
                label: {
                    style: {
                        fontSize: 11,
                    },
                    autoRotate: false,
                    autoHide: false,
                    formatter: (name) => FirstLastName(name),
                },
            },
            meta: {
                type: {
                    alias: "mostSatisfied",
                },
                sales: {
                    alias: "Classification",
                },
            },
        });
    const [
        mostUnsatisfiedConsultantsConfig,
        setMostUnsatisfiedConsultantsConfig,
    ] = useState({
        data: [],
        width: 900,
        height: 150,
        xField: "employeeName",
        yField: "level",
        color: "red",
        label: {
            position: "middle",
            style: {
                fill: "#FFFFFF",
                opacity: 0.6,
            },
        },
        xAxis: {
            label: {
                style: {
                    fontSize: 11,
                },
                autoRotate: false,
                autoHide: false,
                formatter: (name) => FirstLastName(name),
            },
        },
        meta: {
            type: {
                alias: "mostUnsatisfied",
            },
            sales: {
                alias: "Classification",
            },
        },
    });

    useEffect(async () => {
        document.title = `${appTitle} - Home`;
    }, []);

    useEffect(async () => {
        await loadEmployeesSatisfaction();
        await loadEmployeeCounters();
        setLoading(false);
    }, []);

    useEffect(async () => {
        await loadMonthlyEventsCount();
    }, [monthlyEventsSearch]);

    useEffect(async () => {
        await loadContractProposalsStatistics();
    }, [contractProposalMonth, contractProposalYear]);

    useEffect(async () => {
        await loadUserEmployeeFollowUpEventsCounter();
        await loadEmployeeFollowUpEventStatistics();
    }, [employeeFollowUpEventMonth, employeeFollowUpEventYear]);

    useEffect(async () => {
        await loadOffersStatistics();
    }, [offerTypeMonth, offerTypeYear]);

    const loadEmployeesSatisfaction = async () => {
        await getEmployeesSatisfactionLevels().then((res) => {
            if (res.status === 200) {
                setCompanySatisfaction(res.data.companySatisfaction);
                setProjectSatisfaction(res.data.projectSatisfaction);
                setClientSatisfaction(res.data.clientSatisfaction);
            }
        });
    };

    const loadMonthlyEventsCount = async () => {
        let monthValueList = [];
        let colorList = [];
        setMonthlyEventsList([]);
        setBadgesColors([]);
        switch (monthlyEventsSearch) {
            case "All":
                for (let month = 1; month <= 12; month++) {
                    await getEmployeeFollowUpEventsByDateAndStatusCounter(
                        month,
                        year,
                        // -1
                    ).then((res) => {
                        if (res.status === 200) {
                            monthValueList.push(res.data);
                            colorList.push("red");
                        }
                    });
                }
                break;
            case "Done":
                for (let month = 1; month <= 12; month++) {
                    await getEmployeeFollowUpEventsByDateAndStatusCounter(
                        month,
                        year,
                        FollowUpEventStatus.Done
                    ).then((res) => {
                        if (res.status === 200) {
                            monthValueList.push(res.data);
                            colorList.push("green");
                        }
                    });
                }
                break;
            case "Not done":
                for (let month = 1; month <= 12; month++) {
                    await getEmployeeFollowUpEventsByDateAndStatusCounter(
                        month,
                        year,
                        FollowUpEventStatus.NotDone
                    ).then((res) => {
                        if (res.status === 200) {
                            monthValueList.push(res.data);
                            if (res.data == 0) colorList.push("green");
                            else colorList.push("red");
                        }
                    });
                }
                break;
            case "Not assigned":
                for (let month = 1; month <= 12; month++) {
                    await getEmployeeFollowUpEventsByDateAndStatusCounter(
                        month,
                        year,
                        FollowUpEventStatus.NotAssigned
                    ).then((res) => {
                        if (res.status === 200) {
                            monthValueList.push(res.data);
                            if (res.data == 0) colorList.push("green");
                            else colorList.push("red");
                        }
                    });
                }
                break;
        }
        setMonthlyEventsList(monthValueList);
        setBadgesColors(colorList);
    };

    const loadEmployeeCounters = async () => {
        await getEmployeeCounters().then((res) => {
            if (res.status === 200) {
                setAtiveConsultantsCount(res.data.activeEmployeesCount);
                setNewConsultantsCount(res.data.newEmployeesCount);
                setResignatedConsultantsCount(res.data.resignatedEmployeesCount);
            }
        });
    };

    const loadContractProposalsStatistics = async () => {
        await getContractProposalsStatistics(
            contractProposalMonth,
            contractProposalYear
        ).then((res) => {
            if (res.status === 200) {
                setContractProposalData(res.data);
            }
        });
    };

    const loadUserEmployeeFollowUpEventsCounter = async () => {
        await getUserEmployeeFollowUpEventsCounter(
            employeeFollowUpEventMonth,
            employeeFollowUpEventYear
        ).then((res) => {
            if (res.status === 200) {
                setUserEmployeeFollowUpEventData(res.data);
            }
        });
    };

    const loadEmployeeFollowUpEventStatistics = async () => {
        await getEmployeeFollowUpEventStatistics(
            employeeFollowUpEventMonth,
            employeeFollowUpEventYear
        ).then((res) => {
            if (res.status === 200) {
                let results = res.data.userEmployeeFollowUpEvents.map((efs) => {
                    if (efs.userName == null) {
                        efs.userName = "Canceled/ Not Assigned";
                    }
                });
                setEmployeeFollowUpEventData(res.data);
            }
        });
    };

    const loadOffersStatistics = async () => {
        await getOffersStatistics(offerTypeMonth, offerTypeYear).then((res) => {
            if (res.status === 200) {
                res.data.offerTypesStatistic.map(
                    (r) => (r.month = parseInt(offerTypeMonth))
                );
                setOfferTypeData(res.data);
            }
        });
    };

    const followUpEventsProgressconfig = {
        height: 150,
        width: 150,
        autoFit: false,
        percent:
            userEmployeeFollowUpEventData &&
                userEmployeeFollowUpEventData.employeeFollowUpEventDone != 0
                ? userEmployeeFollowUpEventData.employeeFollowUpEventDone /
                (userEmployeeFollowUpEventData.employeeFollowUpEventDone +
                    userEmployeeFollowUpEventData.employeeFollowUpEventUndone)
                : 0,
        color: ["#7d6ef9", "#E8EDF3"],
        innerRadius: 0.85,
        radius: 0.98,
        statistic: {
            title: {
                style: {
                    color: "#363636",
                    fontSize: "12px",
                    lineHeight: "14px",
                },
                formatter: () =>
                    `${userEmployeeFollowUpEventData
                        ? userEmployeeFollowUpEventData.employeeFollowUpEventDone
                        : 0
                    } out of 
        ${userEmployeeFollowUpEventData
                        ? userEmployeeFollowUpEventData.employeeFollowUpEventDone +
                        userEmployeeFollowUpEventData.employeeFollowUpEventUndone
                        : 0
                    }`,
            },
        },
    };

    const loadNewConsultantsData = (resign) => {
        setNewResignConsultants(resign);
        getNewEmployees(30, resign)
            .then((res) => {
                if (res.status == 200) {
                    setNewConsultants(res.data);
                    setIsEntriesAndExitsModalVisible(true);
                } else {
                    AdnMessageError();
                }
            })
            .catch((err) => {
                console.log(err);
                AdnMessageError();
            });
    };

    const handleModalClick = (title) => {
        const satisfied = getEmployeeStatisfactionLevelsDetails(
            30,
            true,
            20,
            title.toLowerCase()
        )
            .then((res) => {
                if (res.status == 200) {
                    setMostSatisfiedConsultantsConfig({
                        ...mostSatisfiedConsultantsConfig,
                        data: res.data,
                    });
                } else {
                    AdnMessageError();
                }
            })
            .catch((err) => {
                console.log(err);
                AdnMessageError();
            });
        const unsatisfied = getEmployeeStatisfactionLevelsDetails(
            30,
            false,
            20,
            title.toLowerCase()
        )
            .then((res) => {
                if (res.status == 200) {
                    setMostUnsatisfiedConsultantsConfig({
                        ...mostUnsatisfiedConsultantsConfig,
                        data: res.data,
                    });
                } else {
                    AdnMessageError();
                }
            })
            .catch((err) => {
                console.log(err);
                AdnMessageError();
            });
        Promise.all([satisfied, unsatisfied]).then(() =>
            setIsSatisfactionModalVisible(true)
        );
    };

    const onRadioChange = (value) => {
        setMonthlyEventsSearch(value.target.value);
    };

    const handleModalCancel = () => {
        setIsSatisfactionModalVisible(false);
        setIsEntriesAndExitsModalVisible(false);
    };

    const handleContractProposalMonth = (value) => {
        setContractProposalMonth(value);
    };

    const handleContractProposalYear = (value) => {
        setContractProposalYear(value);
    };

    const handleEmployeeFollowUpEventMonth = (value) => {
        setEmployeeFollowUpEventMonth(value);
    };

    const handleEmployeeFollowUpEventYear = (value) => {
        setEmployeeFollowUpEventYear(value);
    };

    const handleOfferTypeMonth = (value) => {
        setOfferTypeMonth(value);
    };

    const handleOfferTypeYear = (value) => {
        setOfferTypeYear(value);
    };

    const handleMonthChange = (month) => {
        navigate(
            AppRoutes.followUpEventList.createPathWithSearch(
                "",
                month,
                year,
                monthlyEventsSearch == "All" ? "" : monthlyEventsSearch,
                "",
                ""
            )
        );
    };

    const handleColorChange = (month) => {
        let color;
        if (month == currentMonth) {
            color = "#164170";
        } else if (month > currentMonth) {
            color = "#cbcbcb";
        } else color = "#0686cb";
        return color;
    };

    const handleActiveConsultantsClick = () => {
        navigate(AppRoutes.consultantList.createPath());
    };

    return (
        <>
            <HomeForm
                offerTypeData={offerTypeData}
                handleColorChange={handleColorChange}
                handleMonthChange={handleMonthChange}
                employeeFollowUpEventData={employeeFollowUpEventData}
                followUpEventsProgressconfig={followUpEventsProgressconfig}
                loading={loading}
                activeConsultantsCount={activeConsultantsCount}
                newConsultantsCount={newConsultantsCount}
                resignatedConsultantsCount={resignatedConsultantsCount}
                handleModalClick={handleModalClick}
                handleActiveConsultantsClick={handleActiveConsultantsClick}
                handleListConsultantsClick={loadNewConsultantsData}
                companySatisfaction={companySatisfaction}
                projectSatisfaction={projectSatisfaction}
                clientSatisfaction={clientSatisfaction}
                handleContractProposalMonth={handleContractProposalMonth}
                handleContractProposalYear={handleContractProposalYear}
                contractProposalData={contractProposalData}
                handleEmployeeFollowUpEventMonth={handleEmployeeFollowUpEventMonth}
                handleEmployeeFollowUpEventYear={handleEmployeeFollowUpEventYear}
                handleOfferTypeMonth={handleOfferTypeMonth}
                handleOfferTypeYear={handleOfferTypeYear}
                onRadioChange={onRadioChange}
                monthlyEventsList={monthlyEventsList}
                badgesColors={badgesColors}
            />

            <SatisfactionDetailModal
                isSatisfactionModalVisible={isSatisfactionModalVisible}
                modalTitle={modalTitle}
                handleModalCancel={handleModalCancel}
                mostUnsatisfiedConsultantsConfig={mostUnsatisfiedConsultantsConfig}
                mostSatisfiedConsultantsConfig={mostSatisfiedConsultantsConfig}
            />

            <ConsultantsEntryAndExitDetailModal
                isEntriesAndExitsModalVisible={isEntriesAndExitsModalVisible}
                handleModalCancel={handleModalCancel}
                newConsultants={newConsultants}
                newResignConsultants={newResignConsultants}
                loadNewConsultantsData={loadNewConsultantsData}
            />
        </>
    );
};

export default ManageHome;
